import type { JSX } from "react";
import { Toggle } from "@/shared/ui";
import { ComparisonMode } from "@/pages/assessment/_components";

interface ComparisonToggleProps {
  value: ComparisonMode;
  onChange: (value: ComparisonMode) => void;
}

export const ComparisonToggle = ({ value, onChange }: ComparisonToggleProps): JSX.Element => {
  return (
    <div className="flex items-center justify-end gap-2.5 text-xs">
      <span className={value === "current" ? "text-eerie-black" : "text-gray-500"}>Current role</span>
      <Toggle checked={value === "next"} onChange={(checked) => onChange(checked ? "next" : "current")} />
      <span className={value === "next" ? "text-eerie-black" : "text-gray-500"}>Next role</span>
    </div>
  );
};
